import { Minus, Plus } from 'lucide-react';

interface ZoomControlProps {
  orientation: 'portrait' | 'landscape';
  safeAreaTop: number;
  safeAreaBottom: number;
  currentZoom: number;
  onZoomChange: (zoom: number) => void;
}

export function ZoomControl({ 
  orientation, 
  safeAreaTop,
  safeAreaBottom,
  currentZoom,
  onZoomChange,
}: ZoomControlProps) {
  const handleZoomIn = () => {
    onZoomChange(Math.min(currentZoom + 0.5, 3));
  };

  const handleZoomOut = () => {
    onZoomChange(Math.max(currentZoom - 0.5, 1));
  };

  return (
    <div
      style={{
        position: 'absolute',
        right: orientation === 'portrait' ? '16px' : `${safeAreaBottom + 88}px`,
        top: orientation === 'portrait' ? `${safeAreaTop + 80}px` : '50%',
        transform: orientation === 'landscape' ? 'translateY(-50%)' : 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        background: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(10px)',
        padding: '8px',
        borderRadius: '24px',
        zIndex: 20,
      }}
    >
      <button
        onClick={handleZoomIn}
        style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Plus size={20} color="rgba(255, 255, 255, 0.9)" />
      </button>
      <div
        style={{
          width: '36px',
          height: '1px',
          background: 'rgba(255, 255, 255, 0.3)',
        }}
      />
      <button
        onClick={handleZoomOut}
        style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Minus size={20} color="rgba(255, 255, 255, 0.9)" />
      </button>
    </div>
  );
}
